import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import DispatchViewTable from './dispatchviewtable';
import AddDisptachheading from './adddisptachheading';
import { refreshAccessToken, API_CONFIG, getHeaders } from "../../config/api";
import DateLabelInput from '../common/forms/DateLabelInput';
import { Search } from 'lucide-react';
import { MdLockReset } from 'react-icons/md';
import SelectMenu from '../common/forms/selectmenu';
import { useAuth } from "../../context/AuthContext"; // Auth context

export default function DispatchView() {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [customers, setCustomers] = useState([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [dispatchstartDate, setDispatchStartDate] = useState("");
  const [dispatchendDate, setDispatchEndDate] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const { logout } = useAuth();
  useEffect(() => {
    if (location.state?.showToast) {
      toast.success(location.state.message);
      // Clear state so toast doesn't reappear on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  // Reset filters
  const resetFilters = () => {
    setSearchTerm("");
    setDispatchStartDate("");
    setDispatchEndDate("");
    setSelectedCustomer("");
  };
  const fetchCustomers = useCallback(async () => {
    setLoadingCustomers(true);

    try {
      const url = new URL(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CUSTOMERS.GET_ALL}`);
      url.searchParams.append("mode", "edit");

      let response = await fetch(url.toString(), {
        method: "GET",
        headers: getHeaders(true),
      });

      if (response.status === 401) {
        console.warn("Access token expired. Attempting refresh...");
        const newToken = await refreshAccessToken();

        if (newToken) {
          response = await fetch(url.toString(), {
            method: "GET",
            headers: getHeaders(true),
          });
        } else {
          console.error("Refresh token failed. Logging out...");
          logout();
          return;
        }
      }

      const result = await response.json();

      if (result.status === 200 && Array.isArray(result.data)) {
        setCustomers(
          result.data.map((customer) => ({
            label: customer.name,
            value: customer.name,
          }))
        );
      } else {
        setCustomers([]);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomers([]);
    } finally {
      setLoadingCustomers(false);
    }
  }, [logout]); // 👈 EMPTY array makes the function stable

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);
  const formatLabel = (value) => {
    return value
      ? value
        .toLowerCase()
        .split(",")
        .map(part =>
          part
            .trim()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        )
        .join(", ")
      : "";
  };
  return (
    <div className="p-2 px-1">
      <AddDisptachheading />
      <div className="flex flex-wrap justify-center items-center gap-4 mb-4">
        {/* Search Input */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
          <input
            type="text"
            placeholder="Search by DI No.  Ex No. or BI No."
            className="h-11 pl-10 pr-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-black"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className='w-36'>
          <div className='w-36'>
            <SelectMenu
              label="Customer"
              name="customer"
              options={customers.map(opt => ({
                ...opt,
                label: formatLabel(opt.label)
              }))}
              loading={loadingCustomers}
              value={selectedCustomer}           // FIXED
              onChange={(val) => setSelectedCustomer(val)}   // FIXED
              searchable
              usePortal
            />
          </div>

        </div>
        <div className='w-36'>
          <DateLabelInput
            label="Dispatch Start Date"
            type="date"
            value={dispatchstartDate}
            onChange={(e) => setDispatchStartDate(e.target.value)}
          />
        </div>
        <div className='w-36'>
          <DateLabelInput
            label="Dispatch End Date"
            type="date"
            value={dispatchendDate}
            onChange={(e) => setDispatchEndDate(e.target.value)}
          />
        </div>

        {/* Reset button */}
        {(searchTerm || dispatchstartDate || dispatchendDate || selectedCustomer) && (
          <button
            onClick={resetFilters}
            className="flex items-center justify-center h-11 w-11"
            title="Reset Filters"
          >
            <MdLockReset size={20} />
          </button>
        )}
      </div>
      <DispatchViewTable
        searchTerm={searchTerm}
        dispatchstartDate={dispatchstartDate}
        dispatchendDate={dispatchendDate}
        selectedCustomer={selectedCustomer}
      />
    </div>
  )
}
